import type { FC, PropsWithChildren, RefObject } from "react";
import React, { memo } from "react";
import clsx from "clsx";
import styles from "./SubSectionWrapper.module.scss";
import { useCarConfigSelector } from "../../../../../../redux/store";
import { CarConfigConfigureSectionsLbx } from "../../../../../../utils/types/SectionTypesLbx";

type SectionWrapperProps = {
    sectionId: CarConfigConfigureSectionsLbx;
    sectionRef?: RefObject<HTMLElement>;
};

const SubSectionWrapper: FC<PropsWithChildren<SectionWrapperProps>> = ({ children, sectionRef, sectionId }) => {
    const sectionIsActive = useCarConfigSelector((state) => state.carConfigNavigation.activeSection === sectionId);
    const sectionIsPassed = useCarConfigSelector(
        (state) => state.carConfigNavigation.passedSection.includes(sectionId) ?? false,
    );
    return (
        <section
            data-testid={sectionId}
            id={sectionId !== CarConfigConfigureSectionsLbx.AtmosphereWelcome ? sectionId : undefined}
            ref={sectionRef}
            className={clsx(
                styles[sectionId],
                styles["config-section"],
                sectionIsActive && styles.current,
                sectionIsPassed && styles.processed,
            )}
            data-section={sectionId}
        >
            {children}
        </section>
    );
};

export default memo(SubSectionWrapper);
